import {
  collection,
  getDocs,
  getFirestore,
  query,
  where,
} from "firebase/firestore";
import { Album } from "../../models/album/types";
import { DB_NODES } from "../../../../db/constants/nodeNames";

async function fetchAlbums(): Promise<Album[]> {
  const db = getFirestore();
  const albumsCollection = collection(db, DB_NODES.ALBUMS);
  const q = query(albumsCollection, where(DB_NODES.ACTIVE, "==", true));

  const querySnapshot = await getDocs(q);
  const albums: Album[] = [];

  querySnapshot.forEach((documentSnapshot) => {
    const album = documentSnapshot.data() as Album;

    albums.push({
      categories: album.categories,
      color: album.color,
      id: documentSnapshot.id,
      index: album.index,
    });
  });

  return albums;
}

export const albumService = { fetchAlbums };
